import 'angular:locale/data:nl-BE';
import 'angular:locale/data:en-BE';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
